import { SourceBasedExpression } from '../Expression.js';
export class ToRealExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return Number.parseFloat(source);
    }
}
//# sourceMappingURL=ToRealExpression.js.map